module.exports = __webpack_public_path__ + "img/collect.a791d729.png";